import Configuration from './Configuration';
import Settings from '@material-ui/icons/Settings';

export default {
    home: Configuration,
    icon: Settings,
};
